import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../shared/components/ui';

export function CreateEstimateHero({ hasHistoricalData = true }) {
  const navigate = useNavigate();

  const handleCreateEstimate = () => {
    navigate('/estimates/new');
  };

  const handleUploadEstimates = () => {
    navigate('/estimates/upload');
  };

  return (
    <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl p-8 mb-8 text-white">
      <div className="flex flex-col md:flex-row items-center justify-between gap-6">
        <div>
          <h2 className="text-2xl font-bold mb-2">Create a New Estimate</h2>
          <p className="text-blue-100 text-sm">
            Get AI-assisted pricing based on your completed historical estimates
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            variant="primary"
            size="lg"
            onClick={handleCreateEstimate}
            className="!bg-white !text-blue-700 hover:!bg-blue-50 focus:!ring-white"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            Create New Estimate
          </Button>
          {!hasHistoricalData && (
            <Button
              variant="outline"
              size="lg"
              onClick={handleUploadEstimates}
              className="border-white text-white hover:bg-blue-500"
            >
              Upload Historical Estimates
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}

export default CreateEstimateHero;
